<template>
  <section class="service-industry">
    <div class="section">
      <h5 class="section-title">为多行业客户提升营销效率</h5>
      <div class="industry-list">
        <div class="industry-item">
          <img class="icon-service" src="@/assets/images/1.png" />
          <p class="industry-name">美妆个护</p>
        </div>
        <div class="industry-item">
          <img class="icon-service" src="@/assets/images/2.png" />
          <p class="industry-name">食品饮料</p>
        </div>
        <div class="industry-item">
          <img class="icon-service" src="@/assets/images/3.png" />
          <p class="industry-name">鞋服配饰</p>
        </div>
        <div class="industry-item">
          <img class="icon-service" src="@/assets/images/4.png" />
          <p class="industry-name">母婴用品</p>
        </div>
      </div>
      <div class="industry-list">
        <div class="industry-item">
          <img class="icon-service" src="@/assets/images/5.png" />
          <p class="industry-name">3C数码</p>
        </div>
        <div class="industry-item">
          <img class="icon-service" src="@/assets/images/6.png" />
          <p class="industry-name">家用电器</p>
        </div>
        <div class="industry-item">
          <img class="icon-service" src="@/assets/images/7.png" />
          <p class="industry-name">汽车</p>
        </div>
        <div class="industry-item">
          <img class="icon-service" src="@/assets/images/8.png" />
          <p class="industry-name">家居家纺</p>
        </div>
        <div class="industry-item">
          <img class="icon-service" src="@/assets/images/9.png" />
          <p class="industry-name">家庭清洁</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "serviceIndustry",
};
</script>

<style>
</style>